import axios from '../lib/axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { errorHandling, serializeAxiosError } from '../utils/utils'

function toUploadFormData(input) {
  if (typeof FormData !== 'undefined' && input instanceof FormData) {
    return input
  }

  const formData = new FormData()
  const files = Array.isArray(input)
    ? input
    : input && typeof input.length === 'number'
      ? Array.from(input)
      : []

  files.forEach((file) => {
    if (file) {
      formData.append('files[]', file)
    }
  })

  return formData
}

// 1- UPLOAD FILE
export const uploadFile = createAsyncThunk(
  'tempUpload/uploadFile',
  async ({ formData, onUploadProgress }, thunkAPI) => {
    const { rejectWithValue, getState } = thunkAPI
    try {
      const state = getState()
      const { profile } = state.auth
      const url = profile ? '/upload_file' : '/guest/upload-file'
      const payload = toUploadFormData(formData)
      const { data } = await axios.post(url, payload, {
        onUploadProgress: (progressEvent) => {
          if (typeof onUploadProgress !== 'function' || !progressEvent.total) {
            return
          }
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          onUploadProgress(percentCompleted)
        },
      })
      return data
    } catch (error) {
      return rejectWithValue(serializeAxiosError(error))
    }
  }
)

// 2- REMOVE FILE
export const removeFile = createAsyncThunk(
  'tempUpload/removeFile',
  async (path, thunkAPI) => {
    const { rejectWithValue, getState } = thunkAPI
    try {
      const state = getState()
      const { profile } = state.auth
      const url = profile ? '/remove_file' : '/guest/remove-file'
      const { data } = await axios.post(url, { path })
      return data
    } catch (error) {
      return rejectWithValue(serializeAxiosError(error))
    }
  }
)

export const tempUploadSlice = createSlice({
  name: 'tempUpload',
  initialState: {
    loadingUpload: false,
    loadingDelete: false,
    error: null,
  },
  reducers: {
    clearUploadError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    // 1- UPLOAD FILE
    builder.addCase(uploadFile.pending, (state) => {
      state.loadingUpload = true
      state.error = null
    })
    builder.addCase(uploadFile.fulfilled, (state) => {
      state.loadingUpload = false
    })
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.loadingUpload = false
      state.error = errorHandling(action.payload)
    })

    // 2- REMOVE FILE
    builder.addCase(removeFile.pending, (state) => {
      state.loadingDelete = true
      state.error = null
    })
    builder.addCase(removeFile.fulfilled, (state) => {
      state.loadingDelete = false
    })
    builder.addCase(removeFile.rejected, (state, action) => {
      state.loadingDelete = false
      state.error = errorHandling(action.payload)
    })
  },
})

export const { clearUploadError } = tempUploadSlice.actions

export default tempUploadSlice.reducer
